/* eslint-disable max-len */
import React from 'react';
import styled from 'styled-components';

const StyledSVG = styled.svg`
  .st0 {
    fill: #00897d;
  }
  .st1 {
    fill: #ffffff;
  }
  max-width: 12vw;
`;
export const SVG = ({ className, showSimpleVersion = false }: { className?: string; showSimpleVersion?: boolean }) =>
  showSimpleVersion ? (
    <StyledSVG xmlns='http://www.w3.org/2000/svg' className={className} viewBox='0 0 28.046 39.555'>
      <path
        d='M9.128 4.63c1.482-.846 3.122-1.35 4.895-1.35 1.773 0 3.387.504 4.868 1.35a47.65 47.65 0 0 0-1.19 2.17c-1.191-.688-2.435-1.032-3.678-1.032-1.27 0-2.487.344-3.678 1.032-.45-.82-.846-1.535-1.217-2.17M23.31 8.652a22.951 22.951 0 0 1-1.138 2.725c2.117 3.36 3.36 7.62 3.36 11.483 0 3.757-1.217 7.435-3.36 10.028-1.561 1.905-4.233 4.18-8.15 4.18-3.915 0-6.587-2.275-8.148-4.18-2.143-2.62-3.36-6.27-3.36-10.028 0-3.863 1.27-8.123 3.386-11.483-.423-.794-.767-1.693-1.138-2.725C1.746 12.594 0 18.07 0 22.86c0 4.868 1.746 8.97 3.942 11.615 2.46 2.99 5.874 5.08 10.08 5.08 4.208 0 7.647-2.09 10.082-5.08 2.17-2.646 3.942-6.747 3.942-11.615-.027-4.789-1.773-10.266-4.736-14.208'
        className='st0'
      />
      <path
        d='M22.172 11.377c.582-1.164 1.085-2.46 1.614-4.18.609-1.958 1.111-5.318.344-6.562-.265-.423-.635-.582-.873-.609C23.177 0 23.125 0 23.045 0c-1.058 0-2.328 1.138-5.344 6.8-1.191-.688-2.435-1.032-3.678-1.032-1.244 0-2.487.344-3.678 1.032C7.33 1.138 6.06 0 4.975 0c-.08 0-.133 0-.213.026a1.33 1.33 0 0 0-.873.609c-.767 1.27-.264 4.604.344 6.562.53 1.746 1.032 3.016 1.614 4.18-2.116 3.36-3.36 7.62-3.36 11.483 0 3.784 1.217 7.435 3.36 10.028 1.561 1.905 4.234 4.18 8.15 4.18 3.915 0 6.614-2.275 8.149-4.18 2.143-2.62 3.36-6.27 3.36-10.028.026-3.863-1.217-8.123-3.334-11.483'
        className='st1'
      />
      <path
        d='M72.2 89.6c1.1-1.4-.6-2.4-1.1-2.7-.2-.1-.2-.3-.2-.5 1.2-3 4-4.6 6-3.3 1.7 1 2 4.9 0 8.8-1.9 3.7-6 5.1-7.7 4.1-1.1-.8-1.3-2.3-.2-5.8.1-.4.3-.5.7-.3.3.1 1.7.7 2.5-.3m23.7 23.7-19.2.1c.2.7.2 1.5.1 2.3l19 .1c.7 0 1.2-.6 1.2-1.2.1-.8-.5-1.3-1.1-1.3m3-4.8c0 .6-.5 1.2-1.1 1.2l-21.5 1.1c-1.3-3.3-4.6-2.8-4.6-5.6 0-1.5.8-2.1 1.5-3 3.1-3.7 8.4-8.8 9-16.3.3-4.7-.8-11-4.6-11.7-7.2-1.5-14.4 15-14.4 25.4 0 4.2-.1 5.5 1.5 8 .9 1.2 2 2.8 1.8 4.5-.2 2.1-2.2 2.7-3.2 3.7-3 2.9.1 7.7 5.6 7.7 3.7 0 6.7-1.9 7.5-5.3l16.9.9c.6.1 1.1.6 1.1 1.2s-.6 1.1-1.2 1.1l-13.7-.9c-3.8 6.7-15 13.1-19.6 13.1-4.6 0-15.7-6.4-19.6-13.1l-13.7.9c-.6 0-1.2-.4-1.2-1.1-.1-.6.5-1.1 1.1-1.2l16.9-.9c.9 3.4 3.9 5.3 7.6 5.3 5.5 0 8.6-4.8 5.6-7.7-1-1-3-1.6-3.2-3.7-.2-1.6 1-3.2 1.8-4.5 1.7-2.4 1.5-3.8 1.5-8 0-10.4-7.2-26.9-14.4-25.4-3.8.8-5 7-4.6 11.7.6 7.5 5.8 12.6 8.9 16.3.8.9 1.5 1.5 1.5 3 0 2.8-3.2 2.3-4.6 5.6L22 109.7c-.6 0-1.2-.6-1.1-1.2 0-.6.6-1.1 1.2-1.1l14.9.8c1.7-9.9-3.4-22.7-2.4-30.9.8-6.8 5.6-12.3 9.2-14.9.4-.3.5-.8.4-1.3-1.3-4.5-2.8-12-6.8-21.9-4-10-7.5-19.9-9.8-19.7-2.3.3-.7 9.9 4 22.1 4.7 12.2 9.7 17.6 8.3 18.3-1.4.8-3.6-2.6-6.3-7.2-3.2-5.4-5.5-11.2-8-19.2-2.9-9.5-4-22.7-.4-23.3 3.6-.6 10.3 9.9 18.3 24.9C51.3 49.9 54 58.6 54 58.6c.1.3.3.8 1 .7 1.4-.3 3.1-.4 4.7-.4 1.7 0 3.3.1 4.7.4.7.1.9-.3 1-.7 0 0 2.7-8.7 10.4-23.5 8-15.1 14.7-25.5 18.3-24.9 3.9.5 2.9 13.8 0 23.2-2.5 8.1-4.8 13.8-8 19.2-2.7 4.6-4.9 7.9-6.3 7.2-1.3-.7 3.7-6.1 8.3-18.3 4.7-12.2 6.3-21.8 4-22.1-2.3-.2-5.8 9.7-9.8 19.7-4 9.9-5.5 17.4-6.8 21.9-.1.5 0 1 .4 1.3 3.6 2.6 8.4 8.1 9.2 14.9 1 8.2-4.1 21-2.4 30.9l14.9-.8c.7.1 1.3.6 1.3 1.2m-38.8 15.4c-1.3 1.4-3.4 2.9-5.7 3.6 1.6 1.6 3.7 2.4 5.7 2.4 2.1 0 4.1-.8 5.7-2.4-2.4-.7-4.5-2.2-5.7-3.6M49 87c.2-.1.2-.3.2-.5-1.2-3-4-4.6-6-3.3-1.7 1-2 4.9 0 8.8 1.9 3.7 6.1 5.1 7.7 4.1 1.1-.8 1.3-2.3.2-5.8-.1-.4-.3-.5-.7-.3-.2.1-1.7.6-2.4-.3-1.1-1.5.5-2.5 1-2.7m-5.6 26.3-19.1-.1c-.6 0-1.2.6-1.2 1.2s.6 1.2 1.2 1.2l19-.1c-.1-.7 0-1.4.1-2.2'
        style={{
          fill: '#000',
          fillOpacity: 1,
        }}
        transform='matrix(.26458 0 0 .26458 -1.879 -1.879)'
      />
    </StyledSVG>
  ) : (
    <StyledSVG xmlns='http://www.w3.org/2000/svg' className={className} viewBox='0 0 576.4 163.7'>
      <path
        className='st0'
        d='M245,120.8v-14.2h-8.9c-11,0-15.1,3-15.1,11c0,6.7,2.8,9.7,9,9.7C236.6,127.2,240,124.6,245,120.8 M246.6,135.2
  v-4.3c-8.9,8.3-15.7,9.2-22.5,9.2c-13.4,0-21.1-8.2-21.1-22.2c0-15.6,10.1-23.1,31.1-23.1H245v-4c0-8.8-3.1-11.7-12.6-11.7
	c-5.4,0-11.9,0.4-19.3,2.2c-1.4,0.3-2.7-0.7-2.7-2.1v-8.9c0-1.5,1-2.8,2.5-3.2c4.6-1.1,12.2-2.4,23.7-2.4c19.6,0,26.4,6.7,26.4,25.2
	v45.2c0,1.5-1.2,2.7-2.7,2.7h-11C247.8,137.9,246.6,136.7,246.6,135.2'
      />
      <path
        className='st0'
        d='M417,120.8v-14.2h-8.9c-11,0-15.1,3-15.1,11c0,6.7,2.8,9.7,9,9.7C408.7,127.2,412.1,124.6,417,120.8
	 M418.6,135.2v-4.3c-8.8,8.3-15.7,9.2-22.5,9.2c-13.4,0-21.1-8.2-21.1-22.2c0-15.6,10.1-23.1,31-23.1H417v-4
	c0-8.8-3.3-11.7-13.1-11.7c-5.6,0-12.9,0.6-20.4,2.4c-1.4,0.3-2.7-0.7-2.7-2.1v-8.9c0-1.5,1-2.8,2.5-3.1c4.8-1.1,12.9-2.6,24.7-2.6
	c20,0,27,6.7,27,25.2v45.2c0,1.5-1.2,2.7-2.7,2.7h-11C419.9,137.9,418.6,136.7,418.6,135.2'
      />
      <path
        className='st0'
        d='M552.2,140c-17.4,0-24.9-6.4-24.9-25V52.1c0-1.5,1.2-2.7,2.7-2.7h12.6c1.5,0,2.7,1.2,2.7,2.7v14.8h20.2
	c1.5,0,2.7,1.2,2.7,2.7v9.4c0,1.5-1.2,2.7-2.7,2.7h-20.2v33.1c0,7.2,3.1,10.5,9.9,10.5c5.2,0,8.5-0.3,11.5-0.6
	c1.4-0.1,2.6,0.9,2.6,2.3v8.7c0,1.6-1.1,2.9-2.7,3.2C561.2,139.8,558.2,140,552.2,140'
      />
      <path
        className='st0'
        d='M466.6,69.6v4.2c6.9-5.7,14.4-9,23.5-9c14.4,0,22,6.4,22.1,22l0.2,48.5c0,1.5-1.2,2.7-2.7,2.7h-12.8
	c-1.5,0-2.7-1.2-2.7-2.7v-43c0-9-3-11.9-10.5-11.9c-5.5,0-10,1.8-15.5,5.9v49c0,1.5-1.2,2.7-2.7,2.7h-12.6c-1.5,0-2.7-1.2-2.7-2.7
	V69.6c0-1.5,1.2-2.7,2.7-2.7h11C465.4,66.9,466.6,68.1,466.6,69.6'
      />
      <path
        className='st0'
        d='M345.5,135.2V40.9c0-1.5,1.2-2.7,2.7-2.7h12.6c1.5,0,2.7,1.2,2.7,2.7v94.2c0,1.5-1.2,2.7-2.7,2.7h-12.6
	C346.7,137.9,345.5,136.7,345.5,135.2'
      />
      <path
        className='st0'
        d='M311.6,135.2V40.9c0-1.5,1.2-2.7,2.7-2.7H327c1.5,0,2.7,1.2,2.7,2.7v94.2c0,1.5-1.2,2.7-2.7,2.7h-12.6
	C312.8,137.9,311.6,136.7,311.6,135.2'
      />
      <path
        className='st0'
        d='M278.1,135.2V69.6c0-1.5,1.2-2.7,2.7-2.7h12.6c1.5,0,2.7,1.2,2.7,2.7v65.6c0,1.5-1.2,2.7-2.7,2.7h-12.6
	C279.3,137.9,278.1,136.7,278.1,135.2'
      />
      <path
        className='st0'
        d='M277.8,52.6V40.9c0-1.5,1.2-2.7,2.7-2.7h13.3c1.5,0,2.7,1.2,2.7,2.7v11.7c0,1.5-1.2,2.7-2.7,2.7h-13.3
	C279,55.4,277.8,54.2,277.8,52.6'
      />
      <path
        className='st0'
        d='M208,41.2l-28.7,94.3c-0.4,1.4-1.7,2.3-3.1,2.3h-17.4c-1.4,0-2.7-0.9-3.1-2.3l-28.6-94.3c-0.5-1.5,0.7-3,2.2-3
	h14.5c1.5,0,2.8,1,3.1,2.4l20.8,79l20.8-79c0.4-1.4,1.7-2.4,3.1-2.4h14C207.4,38.2,208.5,39.8,208,41.2'
      />
      <path
        className='st0'
        d='M41.6,24.6c5.6-3.2,11.8-5.1,18.5-5.1s12.8,1.9,18.4,5.1c-1.4,2.4-2.9,5.1-4.5,8.2c-4.5-2.6-9.2-3.9-13.9-3.9
	c-4.8,0-9.4,1.3-13.9,3.9C44.5,29.7,43,27,41.6,24.6 M95.2,39.8c-1.4,4-2.8,7.3-4.3,10.3c8,12.7,12.7,28.8,12.7,43.4
	c0,14.2-4.6,28.1-12.7,37.9c-5.9,7.2-16,15.8-30.8,15.8s-24.9-8.6-30.8-15.8c-8.1-9.9-12.7-23.7-12.7-37.9
	c0-14.6,4.8-30.7,12.8-43.4c-1.6-3-2.9-6.4-4.3-10.3C13.7,54.7,7.1,75.4,7.1,93.5c0,18.4,6.6,33.9,14.9,43.9
	c9.3,11.3,22.2,19.2,38.1,19.2c15.9,0,28.9-7.9,38.1-19.2c8.2-10,14.9-25.5,14.9-43.9C113,75.4,106.4,54.7,95.2,39.8'
      />
      <path
        className='st1'
        d='M90.9,50.1c2.2-4.4,4.1-9.3,6.1-15.8c2.3-7.4,4.2-20.1,1.3-24.8c-1-1.6-2.4-2.2-3.3-2.3
	c-0.3-0.1-0.5-0.1-0.8-0.1c-4,0-8.8,4.3-20.2,25.7c-4.5-2.6-9.2-3.9-13.9-3.9s-9.4,1.3-13.9,3.9C34.8,11.4,30,7.1,25.9,7.1
	c-0.3,0-0.5,0-0.8,0.1c-0.9,0.2-2.3,0.7-3.3,2.3c-2.9,4.8-1,17.4,1.3,24.8c2,6.6,3.9,11.4,6.1,15.8c-8,12.7-12.7,28.8-12.7,43.4
	c0,14.3,4.6,28.1,12.7,37.9c5.9,7.2,16,15.8,30.8,15.8c14.8,0,25-8.6,30.8-15.8c8.1-9.9,12.7-23.7,12.7-37.9
	C103.6,78.9,98.9,62.8,90.9,50.1'
      />
      <path
        d='M72.2,89.6c1.1-1.4-0.6-2.4-1.1-2.7c-0.2-0.1-0.2-0.3-0.2-0.5c1.2-3,4-4.6,6-3.3c1.7,1,2,4.9,0,8.8c-1.9,3.7-6,5.1-7.7,4.1
	c-1.1-0.8-1.3-2.3-0.2-5.8c0.1-0.4,0.3-0.5,0.7-0.3C70,90,71.4,90.6,72.2,89.6 M95.9,113.3l-19.2,0.1c0.2,0.7,0.2,1.5,0.1,2.3
	l19,0.1c0.7,0,1.2-0.6,1.2-1.2C97.1,113.8,96.5,113.3,95.9,113.3 M98.9,108.5c0,0.6-0.5,1.2-1.1,1.2l-21.5,1.1h0h0
	c-1.3-3.3-4.6-2.8-4.6-5.6c0-1.5,0.8-2.1,1.5-3c3.1-3.7,8.4-8.8,9-16.3c0.3-4.7-0.8-11-4.6-11.7c-7.2-1.5-14.4,15-14.4,25.4
	c0,4.2-0.1,5.5,1.5,8c0.9,1.2,2,2.8,1.8,4.5c-0.2,2.1-2.2,2.7-3.2,3.7c-3,2.9,0.1,7.7,5.6,7.7c3.7,0,6.7-1.9,7.5-5.3h0l16.9,0.9
	c0.6,0.1,1.1,0.6,1.1,1.2c0,0.6-0.6,1.1-1.2,1.1l-13.7-0.9c-3.8,6.7-15,13.1-19.6,13.1c-4.6,0-15.7-6.4-19.6-13.1l-13.7,0.9
	c-0.6,0-1.2-0.4-1.2-1.1c-0.1-0.6,0.5-1.1,1.1-1.2l16.9-0.9c0.9,3.4,3.9,5.3,7.6,5.3c5.5,0,8.6-4.8,5.6-7.7c-1-1-3-1.6-3.2-3.7
	c-0.2-1.6,1-3.2,1.8-4.5c1.7-2.4,1.5-3.8,1.5-8c0-10.4-7.2-26.9-14.4-25.4c-3.8,0.8-5,7-4.6,11.7c0.6,7.5,5.8,12.6,8.9,16.3
	c0.8,0.9,1.5,1.5,1.5,3c0,2.8-3.2,2.3-4.6,5.6h0l-21.5-1.1c-0.6,0-1.2-0.6-1.1-1.2c0-0.6,0.6-1.1,1.2-1.1l14.9,0.8
	c1.7-9.9-3.4-22.7-2.4-30.9c0.8-6.8,5.6-12.3,9.2-14.9c0.4-0.3,0.5-0.8,0.4-1.3c-1.3-4.5-2.8-12-6.8-21.9c-4-10-7.5-19.9-9.8-19.7
	c-2.3,0.3-0.7,9.9,4,22.1c4.7,12.2,9.7,17.6,8.3,18.3c-1.4,0.8-3.6-2.6-6.3-7.2c-3.2-5.4-5.5-11.2-8-19.2c-2.9-9.5-4-22.7-0.4-23.3
	c3.6-0.6,10.3,9.9,18.3,24.9c7.8,14.8,10.5,23.5,10.5,23.5c0.1,0.3,0.3,0.8,1,0.7c1.4-0.3,3.1-0.4,4.7-0.4c1.7,0,3.3,0.1,4.7,0.4
	c0.7,0.1,0.9-0.3,1-0.7c0,0,2.7-8.7,10.4-23.5c8-15.1,14.7-25.5,18.3-24.9C98,10.7,97,24,94.1,33.4c-2.5,8.1-4.8,13.8-8,19.2
	c-2.7,4.6-4.9,7.9-6.3,7.2c-1.3-0.7,3.7-6.1,8.3-18.3c4.7-12.2,6.3-21.8,4-22.1c-2.3-0.2-5.8,9.7-9.8,19.7c-4,9.9-5.5,17.4-6.8,21.9
	c-0.1,0.5,0,1,0.4,1.3c3.6,2.6,8.4,8.1,9.2,14.9c1,8.2-4.1,21-2.4,30.9l14.9-0.8C98.3,107.4,98.9,107.9,98.9,108.5 M60.1,123.9
	c-1.3,1.4-3.4,2.9-5.7,3.6c1.6,1.6,3.7,2.4,5.7,2.4c2.1,0,4.1-0.8,5.7-2.4C63.4,126.8,61.3,125.3,60.1,123.9 M49,87
	c0.2-0.1,0.2-0.3,0.2-0.5c-1.2-3-4-4.6-6-3.3c-1.7,1-2,4.9,0,8.8c1.9,3.7,6.1,5.1,7.7,4.1c1.1-0.8,1.3-2.3,0.2-5.8
	c-0.1-0.4-0.3-0.5-0.7-0.3c-0.2,0.1-1.7,0.6-2.4-0.3C46.9,88.2,48.5,87.2,49,87 M43.4,113.3l-19.1-0.1c-0.6,0-1.2,0.6-1.2,1.2
	c0,0.6,0.6,1.2,1.2,1.2l19-0.1C43.2,114.8,43.3,114.1,43.4,113.3'
      />
    </StyledSVG>
  );
export default SVG;
